module.exports = __webpack_public_path__ + "static/media/electrum-performance.b853a1c3.md";